import { Folder } from '../types';

export function getFoldersMap(folders: Folder[]): Map<string, Folder> {
  const foldersMap = new Map<string, Folder>();

  const mapFolders = (currentFolders: Folder[]) => {
    for (const folder of currentFolders) {
      foldersMap.set(`${folder.id}`, folder);
      if (folder.subfolders) {
        mapFolders(folder.subfolders);
      }
    }
  };
  mapFolders(folders);

  return foldersMap;
}
